//MINOR DIFFERENCES

import {
    Box,
    Chip,
    Container,
    Grid,
    List,
    ListItem,
    ListItemText,
    Paper,
    Typography,
    useTheme,
} from "@mui/material";
import { useState } from "react";

import useText from "../../../hooks/useText";
import VideoPopoverTrigger from "../VideoPopoverTrigger";


// This block is in Home and not in Account 
//   const Spacer = () => (
//     <Box
//       sx={{
//         height: "40px",
//         backgroundColor: "#ebebeb",
//       }}
//     />
//   );

const IdentityOverview = ({
    identities,
    ...other
}: Record<string, any> & {
    identities: {
        identity: any;
        overview: any;
        key: string;
        motivators: any[];
    }[];
}) => {
    const [activeIdentity, setActiveIdentity] = useState(0);
    const {
        identity,
        overview,
        key: identityKey,
        motivators = [],
    } = identities[activeIdentity];
    const theme = useTheme();
    // @ts-expect-error
    const identityColor = theme.palette.mojoColors.identities[identityKey];
    const text = useText()?.identityOverview.index;
    return (
        <>
            <Box
                sx={{
                    height: "40px",
                    backgroundColor: "#ebebeb",
                }}
            />
            <Box
                {...other}
                sx={{
                    backgroundColor: (t) => t.palette.primary.main,
                    padding: (t) => t.spacing(3, 0),
                    minHeight: "70vh",
                }}
            >
                <Container>
                    <Typography
                        sx={{
                            color: "white",
                            marginBottom: (t) => t.spacing(3),
                        }}
                        variant="h3"
                    >
                        {text.title}
                    </Typography>
                    <div style={{ textAlign: "right" }}>
                        <VideoPopoverTrigger src="/report/video/Your-Identities.mp4" />
                    </div>
                    <Paper
                        sx={{
                            p: (t) => t.spacing(2),
                        }}
                    >
                        <Grid container justifyContent="center">
                            <Grid
                                container
                                item
                                alignItems="center"
                                justifyContent="center"
                                gap={3}
                            >
                                <List dense>
                                    {identities.map((id, index) => (
                                        <ListItem
                                            key={"listItem" + index}
                                            button
                                            onClick={() => setActiveIdentity(index)}
                                        >
                                            <ListItemText
                                                sx={{
                                                    color: (t) =>
                                                        index === activeIdentity
                                                            ? t.palette.secondary.main
                                                            : "black",
                                                }}
                                            >
                                                {`#${index + 1} ${id.identity}`}
                                            </ListItemText>
                                        </ListItem>
                                    ))}
                                </List>
                            </Grid>
                            <Grid item sm={3} xs={12}>
                                <Box
                                    sx={{
                                        padding: (theme) => theme.spacing(4),
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                    }}
                                >
                                    <img
                                        src={`/images/Icon${identityColor.image}.png`}
                                        alt={identity}
                                        style={{
                                            width: "100%",
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid
                                item
                                sm={6}
                                xs={12}
                                sx={{
                                    paddingTop: (theme) => theme.spacing(4),
                                    textAlign: "left",
                                }}
                            >
                                <Typography variant="h6">
                                    {`#${activeIdentity + 1} ${identity}`}
                                </Typography>
                                <Typography variant="body1">{overview}</Typography>
                                {motivators.map((m, i) => (
                                    <Chip
                                        label={m}
                                        sx={{
                                            margin: (theme) => theme.spacing(0.25),
                                        }}
                                        key={`motivator${i}`}
                                    />
                                ))}
                            </Grid>
                        </Grid>
                    </Paper>
                </Container>
            </Box>
        </>
    );
};

export default IdentityOverview;